import { IFundraiser } from 'src/app/fundraiser/models/fundraiser.model';
import { IUser } from './user.model';
import { ISipCause } from './sip-cause.model';
import { IOrder } from 'src/app/common/payment/models/order.model';

export const PAYMENT_DEFAULT_CONFIG: IPaymentConfig = {
  possition: '',
  selectedAmount: 0,
  sipSelectedAmount: 0,
  pCurrency: 'INR',
  donateBtnLabel: 'Contribute {{LABEL_AMOUNT}}',
  formTitle: 'Make a contribution',
  optionsTitle: 'Payment Method',
  // supported_cards: ['MX', 'VISA', 'MASTER', 'STRIPE'],
  otherAmountBtnLabel: 'Other Amount',
  showSlabs: true,
  // formViewType: 'onpage',
  // optionsViewType: 'dialog',
  page: 'f',
  showTutorial: false,
  showSipTutorial: true
};

export const OptionTabs: IOptionsTab[] = [
  { mode: 'UPI', label: 'UPI', mobileLabel: 'UPI', viewAllLabel: 'View All UPI', icon: 'upi' },
  { mode: 'CARD', label: 'Debit/Credit', mobileLabel: 'DEBIT / CREDIT CARD', viewAllLabel: '', icon: 'card' },
  { mode: 'NB', label: 'Net Banking', mobileLabel: 'NETBANKING', viewAllLabel: 'View All Banks', icon: 'bank' },
  { mode: 'PAYTM', label: 'Paytm', mobileLabel: 'PAYTM', viewAllLabel: '', icon: 'wallet' },
  { mode: 'WALLET', label: 'Wallets', mobileLabel: 'WALLETS', viewAllLabel: 'View All Wallets', icon: 'wallet' }
];
export const SupportedOptions = OptionTabs.map(item => item.mode);
export const SipOptionTabs: IOptionsTab[] = [
  { mode: 'Emandate', label: 'Net Banking', icon: 'icon-bank', note: `This Account will be linked to a monthly subscription and future payments will be charged automatically. On clicking the "Contribute" button you will be redirected to the NPCI platform.` },
  { mode: 'CARD', label: 'Credit Card', icon: 'icon-cards', note: `This card will be linked to the subscription and future payments will be charged automatically. On clicking "Contribute" button you might be taken to your bank's website for 3D secure authentication.` },
  { mode: 'UPIRECURRING', label: 'UPI', icon: 'icon-upi', recommended: true, note: 'This Account will be linked to the subscription and future payments will be charged automatically. On clicking "Contribute" button you will be redirected to the UPI app.' },
  { mode: 'WALLET_RECURRING', label: 'Wallet', icon: 'icon-wallet', recommended: true, note: `This wallet account will be linked to the subscription and future payments will be charged automatically. On clicking "Contribute" button you might be taken to Paytm's website.` }
];
export const SipSupportedOptions = SipOptionTabs.map(item => item.mode);


export interface IPaymentConfig {
  possition: string;
  paymentStartFrom?: string;
  failedPaymentStartFrom?: string;
  pCurrency?: string;
  selectedAmount: number;
  sipSelectedAmount: number;
  campaignId?: number;
  formTitle?: string;
  donateBtnLabel?: string;
  disableCard?: boolean;
  enableMaintenanceFee?: boolean;
  showFeeNudge?: boolean;
  hideCaptchaNote?: boolean;
  // lastOrder?: ILastOrder;
  showOtherAmount?: boolean;
  otherAmountBtnLabel?: string;
  origin?: string;
  page?: 'f' | 'op';
  otdContributeRes?: IContribute;
  sipContributeRes?: IContribute;
  optionsRes?: IPaymentOptions;
  optionsTitle?: string;
  visibleTabs?: IOptionsTab[];
  selectedTab?: IOptionsTab;
  min_donation?: number;
  supported_cards?: any;
  user?: IUser;
  showTip?: boolean;
  showSlabs?: boolean;
  tipAmount?: number;
  tipAmountPerc?: number;
  sipTipAmount?: number;
  sipTipAmountPerc?: number;
  txnCost?: number;
  sipTxnCost?: number;
  showDock?: boolean;
  isIndian?: boolean;
  theme?: string;
  sipCauseArray?: ISipCause[];
  sipCause?: string;
  showOtdSipToggle?: boolean;
  showSipCheckOnOtd?: boolean;
  isSipOnOtdChecked?: boolean;
  isSip?: boolean;
  isSipStory?: boolean;
  disable?: boolean;
  ngoSip?: boolean;
  isSipCampaign?: any;
  sendApiResponse?: any;
  showTutorial?: boolean;
  showSipTutorial?: boolean;
  showNationality?: boolean;
  isContributeInitHit?: boolean;
  failedOrderData?: { cartData?: ICartResponse; orderData?: IOrder };
  userForm?: {
    uName?: string;
    uEmail?: string;
    uExt?: string;
    uPhone?: number | string;
    uAddress?: string;
    uPan?: string;
    uPincode?: string | number;
    uAnonymous?: number;
  };
}

export interface ILastOrder {
  iso_currency?: string;
  payment_details?: {
    customer_id?: string;
    last4?: string;
  };
  payment_gateway?: string;
  payment_mode?: string;
  payment_mode_value?: string;
  upi_id?: string;
};

export interface IContribute {
  campaign: IFundraiser;
  default_amount: number;
  min_donation: number;
  selected_currency: string;
  slabs: number[];
  supported_currency: any[];
  address?: boolean;
  anonymous?: boolean;
  ask_citizenship?: boolean;
  ask_email?: boolean;
  ask_pan?: boolean;
  ask_passport?: boolean;
  checkout_type?: string;
  cover_txn_cost_perc?: number;
  is_anonymous?: boolean;
  mandate_fee?: number;
  ngo_sip_campaign?: boolean;
  only_foreign?: boolean;
  only_inr?: boolean;
  pan_required_amount?: number;
  pan_validation_amount?: number;
  pincode?: boolean;
  rewards?: IRewards[];
  show_popular?: boolean;
  sip_cause?: string;
  stripe_link_enabled?: boolean;
  support_fee_perc?: number;
  timestamp?: number;
  payment_methods?: {
    gateway?: string;
    payment_gateway?: string;
    settings?: {
      paypal?: { client_id?: string };
      stripe?: { key?: string }
    }
  };
  insurance?: {
    amount_requested?: number;
    cause_id?: number;
    creator_entity_details_id?: number;
    id?: number;
    raised?: number;
    status_flag?: number;
  };
}

export interface IRewards {
  active_backers_count: number;
  amount: number;
  amount_from: number;
  amount_to: number;
  amount_usd: number;
  backers: number;
  campaign_id: number;
  creation_date: string;
  descp: string;
  display_text: string;
  expected_date: string;
  id: number;
  notes: string;
  status_flag: number;
}

export interface IPaymentOptions {
  gateway?: string;
  options?: {
    CARD?: any;
    CASH?: any;
    Emandate?: any;
    MANUAL?: any;
    NB?: any;
    PAYTMMA?: any;
    PAYTM?: any;
    PREVIOUSPAYMENTGATEWAY?: any;
    PREVPAYGATEWAYRECOMM?: any;
    RECOMMENDED?: string;
    RECOMMENDED_VPA?: string;
    REWARD?: any;
    TOPNB?: any;
    TOPRECURRINGUPI?: any;
    TOPRECURRINGWALLET?: any;
    TOPUPI?: any;
    TOPWALLET?: any;
    UPI?: any;
    UPIRECURRING?: any;
    WALLET?: any;
    credpay?: any;
    payment_offers?: any[];
  };
  setting?: any;
}

export interface IOptionsTab {
  mode: string;
  label: string;
  mobileLabel?: string;
  viewAllLabel?: string;
  icon: string;
  note?: string;
  recommended?: boolean;
  data?: any;
}

export interface IContributeParams {
  currency: string;
  campaign_id?: number | string;
  origin?: string;
  device?: string;
  slab_ab?: any;
  is_story?: boolean;
  currency_only?: string;
  previousCurrency?: string;
  min_donation?: number;
  birthdaytime?: number | string;
  sip_cause?: string;
  skipmin?: boolean;
  checkout_type?: 'standard' | 'custom';
  isQR?: boolean;
  onlyCurrency?: string;
}

export interface ICartParams {
  campaign_id: number;
  currency: string;
  donated_amount: number;
  donor_name: string;
  donor_email: string;
  donor_extension: string;
  donor_phone: string | number;
  donor_city: string;
  donor_country: string;
  campaign_products?: ICartProduct[],
  is_anonymous?: '1' | '0';
  donor_pincode?: number;
  'g-recaptcha-response'?: string;
  tip_amount?: number;
  tip_amount_perc?: number;
  skipmin?: boolean;
  donor_address?: string;
  pan?: string;
  passport?: string;
  reward_id?: string | number;
  indian?: boolean;
  coupon_code?: string | number;
  bulkdonation?: any;
  bulkAmount?: number;
  recurring?: number;
  cause_amount?: number;
  sip_cause?: ISipCause[];
  guest?: 0 | 1;
  device?: string;
  split?: boolean;
  ngo_sip?: number;
  accessToken?: string;
  pledge_more?: number | string;
  wallet_to_autopay?: number;
  transaction_type?: string;
  wallet_recharge?: number | string;
  multicause?: string;
  utm_source?: string;
  utm_medium?: string;
  utm_campaign?: string;
  utm_term?: string;
  utm_content?: string;
  utm_placement?: string;
}

export interface ICartResponse {
  cart?: ICart;
  campaign?: ICartCampaign;
  login?: boolean;
  token?: string;
  user?: any;
}

export interface ICart {
  campaign_id?: number;
  currency?: string;
  donated_amount?: number;
  donated_amount_inr?: number;
  donor_address?: string;
  donor_email?: string;
  donor_entity_details_id?: number;
  donor_name?: string;
  donor_phone?: number;
  donor_pincode?: number;
  id?: number;
  is_anonymous?: number;
  pan?: string;
  recurring?: boolean;
  status_flag?: boolean;
  selected_currency?: string;
  donated_amount_local?: string;
  donor_extension?: string;
  indian?: any;
  tip_amount?: number;
  tip_amount_perc?: number;
  tip_amount_inr?: number;
  skipCardPrefil?: boolean;
  reward_id?: boolean;
  sip_cause?: string;
  sip_cause_str?: string;
  onlySipCauseArr?: string[];
  slabs?: Array<number>;
  bulkdonation?: any;
  plan?: string;
  plan_id?: number;
  vendor?: string;
  timestamp?: number;
  supportFee?: any;
  showKCart?: boolean;
  campaign_products?: ICartProduct[];
  ngo_sip?: number;
  initPossition?: string;
}

export interface ICartCampaign {
  action_at?: any;
  address_1?: string;
  address_2?: string;
  address_3?: string;
  amount_requested?: number;
  beneficiary?: any;
  cause_id?: number;
  cause_id_old?: number;
  corporate_entity_details_id?: number;
  creation_date?: string;
  creator_entity_details_id?: number;
  custom_tag?: string;
  display_type_self?: any;
  end_date?: string;
  entity_details_id?: number;
  event_entity_details_id?: number;
  id?: number;
  ketto_commission?: string;
  manager_id?: number;
  only_foreign?: {
    entity_details_id?: number;
    entity_type?: string;
    info_1?: string;
    info_2?: string;
    info_type?: string;
  }
  owner?: {
    access_url?: string;
    address_1?: string;
    address_2?: string;
    address_3?: string;
    age?: string;
    city?: string;
    creation_time?: string;
    disable_foreign_donation?: number;
    entity_type?: string;
    fname?: string;
    full_name?: string;
    gender?: string;
    id?: number;
    lname?: string;
    no_80g?: boolean;
    pincode?: string;
    profileIncomplete?: boolean;
    status_flag?: number;
    tax_benefit?: boolean;
    user_details_id?: number;
    website_1?: string;
    website_2?: string;
  }
  parent_cause_id?: number;
  parent_entity_details_id?: number;
  priority_self?: number;
  start_date?: string;
  status_flag?: number;
  submitted_at?: string;
  sucess_story_flag?: number;
  title?: string;
  updated_at?: string;
  user_details_id?: number;
  timestamp?: number;
}

export interface ICartProduct {
  id: number;
  name: string;
  per_unit_amount: number;
  unit_count: number;
}

export interface IOrderParams {
  vpa?: string;
  bin?: any;
  campaign_id?: number;
  card_number_fill?: string;
  cart_id?: number;
  customer_id?: number | string;
  donor_pincode?: number | string;
  gateway?: string;
  is_indian?: any;
  is_multi_patient_campaign?: boolean;
  mode?: string;
  cover_txn_cost?: number;
  mode_value?: string;
  page_type?: string;
  payment_gateway?: string;
  subscription_id?: number;
  support_campaign_id?: number;
  tenure?: number;
  cause_amount?: number;
  card_month_fill?: string;
  card_year_fill?: string;
  card_cvv_fill?: string;
  card_name_fill?: string;
  checkout_type?: 'standard' | 'custom';
  origin?: string;
  oneTapPay?: boolean;
  sip_cause?: ISipCause[];
  ab_testname?: string;
  ab_value?: string;
  month_interval?: number;
  transaction_type?: string;
  wallet_to_autopay?: number;
  frequency_term?: string;
  frequency?: number;
  ngo_sip?: 1;
  multicause?: any;
  reward_id?: any;
  cause_id?: any;
  auto_pay_m1?: any;
  ketto_wallet?: number;
  bulkdonation?: any;
  vendor?: any;
  plan?: any;
  plan_id?: any;
  critical_illness?: any;
  coupon_code?: any;
  campaign_products?: any;
  repeat_donor?: any;
  card_no?: any;
  support_fee_ab?: any;
  vpa_type?: any;
  utm_source?: string;
  utm_campaign?: string;
  utm_medium?: string;
  utm_term?: string;
  utm_content?: string;
  utm_placement?: string;
  auth_mode?: string | number;
  account_no?: number | string;
  bank_code?: number | string;
  bank_name?: string;
  ifsc_code?: string;
}

export interface ISendParams {
  order_id?: string;
  token?: any;
  token_1?: any;
  save_card?: any;
  customer_id?: any;
  account_no?: number;
  ifsc_code?: string;
  bank_code?: number | string;
  bank_name?: string;
  auth_mode?: string | number;
  payment_method_change?: any;
  return_url?: string;
  cpm_max?: any;
}

export interface ISendResponse {
  UPI?: boolean;
  charged?: boolean;
  method?: string;
  params?: any;
  url?: string;
  redirect_url?: string;
  order_id?: string;
  status?: string;
  pg_txn_id?: string | number;
  message?: string;
}

export interface IInitPaymentPaarams {
  donor_name?: string;
  donor_email?: string;
  donor_extension?: string;
  donor_phone?: string;
  is_anonymous?: '0' | '1';
  mode?: string;
  mode_value?: string;
  card_number_fill?: string;
  card_month_fill?: string;
  card_year_fill?: string;
  card_cvv_fill?: string;
  card_name_fill?: string;
  donor_pincode?: string | number;
}
